import { useState, useEffect } from "react";
import { ArrowRight, FileText, Users, GraduationCap } from "lucide-react";
import api from "@/lib/api";

const CollegeConsulting = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.getCollegeConsulting().then(res => setData(res.data)).catch(() => {});
  }, []);

  if (!data) return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--lrg-bg)" }}>
      <div className="w-5 h-5 border-2 border-[#0D6B56] border-t-transparent rounded-full animate-spin"></div>
    </div>
  );

  return (
    <div className="pt-16" data-testid="college-consulting-page">
      {/* Hero */}
      <section className="relative py-28 lg:py-36 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src="https://customer-assets-agu9un31.emergentagent.net/job_squash-nexus/artifacts/tryv1g76_IMG_3164.jpeg"
            alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#090B0C]/70"></div>
        </div>
        <div className="container-custom relative z-10">
          <div className="max-w-2xl">
            <p className="overline mb-5">College Consulting</p>
            <h1 className="font-editorial text-4xl sm:text-5xl font-medium text-[#F2EDE4] mb-6">
              College Recruitment<br />Consulting
            </h1>
            <p className="text-sm text-[#F2EDE4]/70 leading-[1.9] max-w-lg">{data.description}</p>
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="section" style={{ background: "var(--lrg-bg)" }}>
        <div className="container-custom">
          <div className="grid md:grid-cols-3 gap-4 mb-16 max-w-4xl">
              <div className="lrg-card">
                <FileText className="w-4 h-4 text-[#0D6B56] mb-5" />
                <h3 className="font-display text-sm font-semibold text-[#F2EDE4] mb-2">Initial Consultation</h3>
                <p className="text-[11px] text-[#3A3D40] leading-[1.8]">In-depth meeting with player and parents to understand goals and aspirations.</p>
              </div>
              <div className="lrg-card">
                <Users className="w-4 h-4 text-[#0D6B56] mb-5" />
                <h3 className="font-display text-sm font-semibold text-[#F2EDE4] mb-2">Profile Review</h3>
                <p className="text-[11px] text-[#3A3D40] leading-[1.8]">Academic performance, test scores, squash rankings, and athletic achievements reviewed.</p>
              </div>
              <div className="lrg-card">
                <GraduationCap className="w-4 h-4 text-[#0D6B56] mb-5" />
                <h3 className="font-display text-sm font-semibold text-[#F2EDE4] mb-2">School Matching</h3>
                <p className="text-[11px] text-[#3A3D40] leading-[1.8]">Schools matched to academic profile, athletic level, and personal aspirations.</p>
              </div>
          </div>

          <div className="border-l border-[#0D6B56] pl-6 py-2 max-w-2xl">
            <p className="text-xs text-[#6B6E71] leading-[1.9]">{data.process.description}</p>
          </div>
        </div>
      </section>

      {/* Colleges */}
      <section className="section" style={{ background: "var(--lrg-surface)" }}>
        <div className="container-custom">
          <div className="text-center mb-12">
            <p className="overline mb-4">Track Record</p>
            <h2 className="font-editorial text-3xl font-medium text-[#F2EDE4]">Where Our Players Have Been Recruited</h2>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-7 gap-3 max-w-4xl mx-auto">
            {data.colleges.map((college, i) => (
              <div key={college} className="text-center py-4 bg-[#090B0C] border border-[#1D1F21]" data-testid={`college-${i}`}>
                <p className="text-[11px] text-[#6B6E71] font-medium">{college}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section" style={{ background: "var(--lrg-bg)" }}>
        <div className="container-custom text-center">
          <h2 className="font-editorial text-3xl font-medium text-[#F2EDE4] mb-3">Ready to start the process?</h2>
          <p className="text-[11px] text-[#3A3D40] mb-10">Contact {data.director} for an initial consultation.</p>
          <a href={`mailto:${data.contact_email}?subject=College%20Consulting`} className="btn-primary" data-testid="college-cta-email">
            Email Us <ArrowRight className="w-3.5 h-3.5" />
          </a>
        </div>
      </section>
    </div>
  );
};

export default CollegeConsulting;
